import { adminRequestsTyped } from "@/api/(requests)/adminTyped";

export type Practice = {
  general_email: string;
  id: string;
  name: string;
  practice_type: string;
};

export async function getPracticeList(): Promise<Practice[]> {
  return adminRequestsTyped.fetch_all_practices();
}
